var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/index.ts
export * from "@jarvis/swagger";

// src/utils.ts
import { v4 as generateUuidV4 } from "uuid";
function generateNumber() {
  return Math.floor(Math.random() * 100);
}
function generateUuid() {
  return generateUuidV4();
}
function getLastPartFromUuid(value) {
  const ids = value.split("-");
  const last = ids[ids.length - 1];
  return last;
}
function generateDate() {
  return new Date();
}
function generateDateString() {
  return generateDate().toString();
}
var userToStudentMapper = (user) => ({
  id: user.id,
  email: user.email,
  schoolName: user.schoolName,
  firstName: user.firstName,
  lastName: user.lastName,
  sisId: user == null ? void 0 : user.sisId,
  createdAt: user.createdAt,
  updatedAt: user.createdAt,
  status: "active",
  type: "student",
  rank: -1,
  grade: -1,
  performanceTrend: "not_enough_data",
  sso: user.sso
});
var getFullName = (entity) => `${entity.firstName} ${entity.lastName}`;
var isSupportedLevel = (classGradeLevel) => {
  const supportedGradeLevels = ["3", "4", "5", "6", "7", "8"];
  return supportedGradeLevels.includes(classGradeLevel);
};

// src/domain-data-generator.ts
function generateInteractionItem(origin) {
  return __spreadValues({
    id: "id 1",
    createdAt: new Date(),
    updatedAt: new Date(),
    startedAt: new Date(),
    completedAt: new Date(),
    userAnswer: "{}",
    itemId: "b7a1186b-8723-4c40-bdd6-cbd0ee429c7f",
    elapsedTimeMs: 0,
    score: 0,
    maxScore: 100,
    downloadUrl: "d1f6j21grqaj2n.cloudfront.net/Nav12.1.1-QTI2.2-FullEnglishBank/SelectedResponse/12.1.1-SRSP-EN-MATH03-36/items/ITEM-LOGIC--643605.xml"
  }, origin);
}
function generateAssignment(origin) {
  const id = generateUuid();
  const last = getLastPartFromUuid(id);
  return __spreadValues({
    id,
    name: `ASSIGNMENT_NAME_${last}`,
    subject: `ASSIGNMENT_SUBJECT_${last}`,
    status: "active",
    dueDate: new Date(),
    createdById: `TEACHER_${last}`,
    classroomId: `CLASSROOM_${last}`,
    numberOfQuestions: generateNumber(),
    createdAt: generateDate(),
    updatedAt: generateDate(),
    totalSubmissions: 4,
    completedSubmissions: 1
  }, origin);
}
function generateSubmission(origin) {
  const id = generateUuid();
  const last = getLastPartFromUuid(id);
  return __spreadValues({
    id,
    grade: 25,
    status: "active",
    studentId: `STUDENT_${last}`,
    assignmentId: `ASSIGNMENT_${last}`,
    classroomId: `CLASSROOM_${last}`,
    trend: "not_enough_data",
    overallGrade: 90,
    createdAt: generateDate(),
    updatedAt: generateDate(),
    completedAt: generateDate(),
    name: `SUBMISSION_NAME_${last}`,
    numberOfQuestions: generateNumber(),
    dueDate: new Date()
  }, origin);
}
function generateStudent(origin) {
  const id = generateUuid();
  const last = getLastPartFromUuid(id);
  return __spreadValues({
    id,
    createdAt: generateDate(),
    updatedAt: generateDate(),
    firstName: `FIRST_NAME_${last}`,
    lastName: `LAST_NAME_${last}`,
    email: last + "@test.com",
    schoolName: `SCHOOL_NAME_${last}`,
    sisId: id,
    type: "student",
    status: "active",
    rank: generateNumber(),
    grade: generateNumber(),
    performanceTrend: "not_enough_data",
    sso: []
  }, origin);
}
function generateSubmissionWithAssignment(origin) {
  return __spreadValues(__spreadProps(__spreadValues({}, generateSubmission()), {
    assignment: __spreadValues({}, generateAssignment(origin == null ? void 0 : origin.assignment))
  }), origin);
}
function generateSubmissionWithStudent(origin) {
  return __spreadValues(__spreadProps(__spreadValues({}, generateSubmission()), {
    student: __spreadValues({}, generateStudent(origin == null ? void 0 : origin.student))
  }), origin);
}
export {
  generateAssignment,
  generateDate,
  generateDateString,
  generateInteractionItem,
  generateNumber,
  generateStudent,
  generateSubmission,
  generateSubmissionWithAssignment,
  generateSubmissionWithStudent,
  generateUuid,
  getFullName,
  getLastPartFromUuid,
  isSupportedLevel,
  userToStudentMapper
};
//# sourceMappingURL=index.js.map